import React, { Component } from 'react';

import './switch.css';

import { bool, string } from 'prop-types';

import { SwitchAPI } from '@philips-emr/tws-components-api';
import { Expression } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, expression } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, defaultClasses, isFunction } from '@philips-emr/tws-utils';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: SwitchAPI })
class Switch extends Component {
  static propTypes = {
    className: string,
    enabled: bool,
    offExpression: expression,
    onBlur: eventListener,
    onChange: eventListener,
    onExpression: expression,
    onFocus: eventListener,
    readOnly: bool,
    showStatus: bool,
    value: bool,
  };

  static defaultProps = {
    offExpression: Expression.OFF,
    onExpression: Expression.ON,
    showStatus: true,
    readOnly: false,
    enabled: true,
  };

  onBlur = () => {
    const { enabled, onBlur } = this.props;

    const shouldTrigger = enabled && isFunction(onBlur);

    if (shouldTrigger) {
      onBlur();
    }
  };

  onChange = () => {
    const { enabled, onChange, readOnly, value: oldValue } = this.props;

    const shouldTrigger = enabled && !readOnly && isFunction(onChange);

    if (shouldTrigger) {
      onChange({ value: !oldValue, oldValue });
    }
  };

  onFocus = () => {
    const { enabled, onFocus } = this.props;

    const shouldTrigger = enabled && isFunction(onFocus);

    if (shouldTrigger) {
      onFocus();
    }
  };

  getClassName() {
    const { value, className } = this.props;

    const defClasses = defaultClasses(this.props);

    return classNames({
      'c-switch': true,
      'is-active': value,
      ...defClasses,
      [className]: Boolean(className),
    });
  }

  renderSwitch() {
    return (
      <div
        className="c-switch__track"
        onBlur={this.onBlur}
        onClick={this.onChange}
        onFocus={this.onFocus}
        x-contrast="bg"
      >
        <div className="c-switch__thumb" tabIndex="0" />
      </div>
    );
  }

  renderStatus() {
    const { offExpression, onExpression, showStatus, value } = this.props;

    if (!showStatus) {
      return null;
    }

    return (
      <div className="c-switch__status">
        {msg(value ? onExpression : offExpression)}
      </div>
    );
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderSwitch()}
        {this.renderStatus()}
      </div>
    );
  }
}

export default Switch;
